<template>
  <div class="sportFootballMatchStatusSettingsItem">
      <el-radio :label="status.id">
        <el-tooltip :content="status.name" placement="bottom">
          <span>{{ status.shortname }}</span>
        </el-tooltip>
      </el-radio>
      <el-date-picker v-if="this.status.date" v-model="date" size="mini" type="datetime" placeholder="" @change="update" />
      <el-checkbox v-if="periodActiveName" v-model="periodActive" />
  </div>
</template>

<script>
export default {
  name: 'SportFootballMatchStatusSettingsItem',
  props: {
    status: Object,
    match: Object
  },
  data () {
    return {
      dateSelected: null
    }
  },
  computed: {
    date: {
      get () { return this.dateSelected || (this.match ? this.match[this.status.date] : null) },
      set (value) { this.dateSelected = value }
    },
    periodActiveName () { return this.status.periodActive },
    periodActive: {
      get () { return this.match ? this.match[this.periodActiveName] : false },
      set (value) {
        const data = { id: this.match.id }
        data[this.periodActiveName] = value
        this.$store.dispatch('Sport/Football/Match/put', data)
      }
    }
  },
  methods: {
    update () {
      const data = {}
      data[this.status.date] = this.dateSelected
      this.$emit('update', data)
    }
  }
}
</script>

<style>
.sportFootballMatchStatusSettingsItem{
  display:block;
  height:30px;
}
.sportFootballMatchStatusSettingsItem .el-radio{
  margin-right:15px
}
.sportFootballMatchStatusSettingsItem .el-radio__label > span{
  font-size:8px;
  display:inline-block;
  width:35px;
  margin-right:0
}
.sportFootballMatchStatusSettingsItem .el-date-editor{
  width:auto
}
.sportFootballMatchStatusSettingsItem .el-date-editor input{
  text-align: center;
  padding:0 5px;
  font-size:8px;
  background-color:var(--color-background-grey);
  border:none;
  border-radius:12px;
  height:25px;
  line-height:25px;
  width:auto;
}
.sportFootballMatchStatusSettingsItem .el-date-editor.el-input .el-input__prefix{
  display:none
}
.sportFootballMatchStatusSettingsItem .el-date-editor .el-input__icon{
  line-height:25px;
}
.sportFootballMatchStatusSettingsItem .el-date-editor .el-input__icon:before{
  color:red;
  background-color:var(--color-background-grey)
}
.sportFootballMatchStatusSettingsItem .el-checkbox{
  margin-left:5px;
}
</style>
